import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAirdrop2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="airdrop-2, free, drop, parachute"><path d="M7.75 21.25V16.75H16.25V21.25H7.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M3.75 10.75L10.9688 16.75M13.0312 16.75L20.25 10.75" stroke="currentColor" strokeWidth="1.5"/><path d="M12 10.75V16.25" stroke="currentColor" strokeWidth="1.5"/><path d="M12 2.75C7.44365 2.75 3.75 6.44365 3.75 11C3.75 11 8.77189 10.4844 12 10.4844C15.2281 10.4844 20.25 11 20.25 11C20.25 6.44365 16.5563 2.75 12 2.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconAirdrop2;
